module.exports = __webpack_public_path__ + "img/Img16b_204743_BhFl-6-361.8df54864.jpg";